module.exports = __webpack_public_path__ + "media/images/new/icons/app_google-9cf4817aed42f539fc3a877ca6a728d7.png";